import {Component, input, InputSignal} from '@angular/core';
import {NotificationForm} from "../../forms/notification.form";
import {TopicNameByCodePipe} from "../../../../pipes/topic-name-by-code.pipe";
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {WasteAreaFormComponent} from "../waste-area-form/waste-area-form.component";

@Component({
  selector: 'app-notification-form',
  standalone: true,
  imports: [
    CommonModule,
    TopicNameByCodePipe,
    ReactiveFormsModule,
    WasteAreaFormComponent
  ],
  templateUrl: './notification-form.component.html'
})
export class NotificationFormComponent {
  public form: InputSignal<NotificationForm | null> = input<NotificationForm | null>(null);
}
